import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import VisualizerFilterList from '../VisualizerFilterList/VisualizerFilterList';
import VisualizerProductList from '../VisualizerProductList/VisualizerProductList';
import VisualizerRoomList from '../VisualizerProductList/VisualizerRoomList';
import Checkbox from '../Checkbox';

import { IconPlusMinus, IconError } from '../Icons';

import { StyledToggleButton, StyledTitle, StyledSubText, StyledPlusMinus, StyledBodyAnimation } from './VisualizerCategoryStyles';

var _ref = React.createElement(IconError, null);

var _ref2 = React.createElement(IconPlusMinus, null);

var VisualizerCategory = function VisualizerCategory(props) {
  // const [active, setActive] = useState(false);
  var _useState = useState({
    filterAry: [],
    selectedFilter: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  useEffect(function () {
    renderFilters();

    if (props.firstCategory) {
      props.handleCategoryActive(props.title);
    }
  }, [renderFilters, props.firstCategory, props.title]);

  var renderFilters = useCallback(function () {
    var filters = [];
    props.categoryItem.products.map(function (product) {
      var option = product.selectedOptions[0].value;
      if (!filters.includes(option) && option !== 'Default Title') filters.push(option);
    });

    if (props.categoryItem.filterType === 'SIZE') {
      var sortOrder = ['Twin/Twin XL', 'Twin', 'Twin XL', 'Full', 'Queen', 'Full/Queen'];

      filters.sort(function (a, b) {
        return sortOrder.indexOf(a) - sortOrder.indexOf(b);
      });
    }
    setFilters({
      filterAry: filters,
      // if options and filterType size, set initial filter state
      selectedFilter: props.categoryItem.filterType === 'SIZE' ? filters[0] : ''
    });
  }, [props.categoryItem.filterType, props.categoryItem.products]);

  var toggleActive = function toggleActive() {
    props.handleCategoryActive(props.title);
  };

  var handleSelectedFilterChange = function handleSelectedFilterChange(filter) {
    setFilters(Object.assign({}, filters, {
      selectedFilter: filter
    }));
  };

  var categoryProducts = props.selectedProducts.filter(function (prod) {
    return prod.category === props.categoryItem.title;
  });
  var hasSelectedProduct = categoryProducts.length > 0;
  var hasError = categoryProducts.filter(function (prod) {
    return !prod.availableForSale;
  }).length > 0;

  return React.createElement(
    'li',
    { className: 'category--' + props.categoryItem.title },
    React.createElement(
      StyledToggleButton,
      { onClick: toggleActive },
      React.createElement(Checkbox, { checked: hasSelectedProduct, width: '25px' }),
      React.createElement(
        StyledTitle,
        { active: props.active || hasSelectedProduct },
        props.categoryItem.displayText
      ),
      React.createElement(
        StyledPlusMinus,
        { active: props.active },
        hasError && _ref,
        _ref2
      )
    ),
    props.active && React.createElement(
      StyledBodyAnimation,
      null,
      props.categoryItem.subText && props.categoryItem.subText.length > 0 && React.createElement(
        StyledSubText,
        null,
        props.categoryItem.subText
      ),
      ['SIZE', 'COLOR'].includes(props.categoryItem.filterType) && React.createElement(VisualizerFilterList, {
        handleSelectedFilterChange: handleSelectedFilterChange,
        filterType: props.categoryItem.filterType,
        filters: filters.filterAry,
        selectedFilter: filters.selectedFilter,
        categoryTitle: props.categoryItem.title
      }),
      React.createElement(VisualizerProductList, {
        active: props.active,
        selectedFilter: filters.selectedFilter,
        selectedProducts: props.selectedProducts,
        products: props.categoryItem.products,
        handleProductSelection: props.handleProductSelection,
        categoryTitle: props.categoryItem.title,
        maxItems: props.categoryItem.maxItems,
        isStaging: props.isStaging
      })
    )
  );
};

VisualizerCategory.propTypes = {
  categoryItem: PropTypes.object.isRequired,
  firstCategory: PropTypes.bool.isRequired,
  selectedProducts: PropTypes.array,
  handleProductSelection: PropTypes.func,
  isStaging: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  categoryActive: PropTypes.object.isRequired,
  handleCategoryActive: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default VisualizerCategory;